import {FlashUIComponent} from "@goodgamestudios/core";
import {Poker2LayoutManager} from "../../Poker2LayoutManager";
import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import Shape = createjs.Shape;
import Rectangle = createjs.Rectangle;
import Stage = createjs.Stage;

export class Poker2TutorialSpotlight extends FlashUIComponent {
    public static NAME: string = "Poker2TutorialSpotlight";

    private  static RADIUS_REDUCE_VALUE: number = 6;

    private _tutorialStage: Stage;
    private _rect: Container;
    private _spotlight: Shape;
    private  _spotlightContainer: Container;
    private _hasSpotLight: boolean;
    private _spotLightRect: Rectangle;
    private _radiusReduceFactor: number;

    /**
     * @param disp
     */
    constructor(disp: MovieClip) {
        super(disp);

        this._tutorialStage = Poker2LayoutManager.getInstance().tutorialStage;

        this._spotlightContainer = new Container();
        this._rect = new Container();

        this._spotlight = new Shape();
        this._spotlight.mouseEnabled = false;
        this._spotlight.compositeOperation = "destination-out";

        this.tutorialSpotlight.addChild(this._rect);
        this._spotlightContainer.addChild(this._spotlight);
        this._tutorialStage.addChild(this._spotlightContainer);

        this._hasSpotLight = false;

        this._radiusReduceFactor = Poker2TutorialSpotlight.RADIUS_REDUCE_VALUE;
    }

    public onTutStateChange(rect: Rectangle = null, scale: boolean = true): void {
        this.show();

        if (rect && scale) {
            rect.x -= Poker2LayoutManager.getInstance().gameNullPoint;
            rect.x /= Poker2LayoutManager.getInstance().scaleFactor;
            rect.y /= Poker2LayoutManager.getInstance().scaleFactor;
            rect.width /= Poker2LayoutManager.getInstance().scaleFactor;
            rect.height /= Poker2LayoutManager.getInstance().scaleFactor;
        }

        this._hasSpotLight = false;

        this.drawSpot(rect);

        this._tutorialStage.addChildAt(this.tutorialSpotlight, 0);
    }

    /**
     * draw semi-transparent surface on all with RoundRect spot
     * @param rect        without:no spot
     */
    private drawSpot(rect: Rectangle = null): void {
        this._spotLightRect = rect;

        const RADIUS_FACTOR: number = 0.9;	// 1 oval .. 0 rectangle
        const EDGE: number = 10;				// spot biger then recht

        var sw: number = 800; // disp.stage.stageWidth / layoutManager.scaleFactor
        var sh: number = 600; // disp.stage.stageHeight / layoutManager.scaleFactor

        // semi-transparent surface on all
        this._rect.graphics.clear();
        this._rect.graphics.beginFill(0x000000, .5);
        this._rect.graphics.drawRect((800 - 9999) / 2, 0, 9999, 9999);
        this._rect.graphics.endFill();

        if (rect) {

            var scaleFactor = Poker2LayoutManager.getInstance().scaleFactor;

            // spot cut
            sw = EDGE + RADIUS_FACTOR * rect.width / 8;
            sh = EDGE + RADIUS_FACTOR * rect.height / 8;
            rect.inflate(sw, sh);
            this._spotlight.graphics.clear();
            this._spotlight.graphics.beginFill(0xffffff, .8);

            let xPos: number = Poker2LayoutManager.getInstance().gameNullPoint + (rect.x * scaleFactor);
            let yPos: number = rect.y * scaleFactor;

            if(scaleFactor < 0.3) {
                // this is to prevent the shape of interfering with the corners when we make the game window very small
                this._radiusReduceFactor += 0.5;
            }
            else {
                this._radiusReduceFactor = Poker2TutorialSpotlight.RADIUS_REDUCE_VALUE;
            }
            
            let radius1: number = (rect.width * RADIUS_FACTOR) / this._radiusReduceFactor;
            let radius2: number = (rect.height * RADIUS_FACTOR) / this._radiusReduceFactor;

            if(rect.width / 2 > rect.height) {
                radius1 /= this._radiusReduceFactor;
            }

            this._spotlight.graphics.drawRoundRect(xPos, yPos, rect.width * scaleFactor, rect.height * scaleFactor, radius1, radius2 );
            rect.inflate(-sw, -sh);
            this._spotlight.graphics.endFill();

            this._hasSpotLight = true;
            this._spotlight.visible = true;
        }
    }

    public updatePosition(): void {
        if(this._spotLightRect) {
            this.drawSpot(this._spotLightRect);
        }
    }

    public hide(): void {
        if(this._spotlight) {
            this._spotlight.graphics.clear();
            this._spotlight.visible = false;
        }

        super.hide();
    }

    //
    // getter & setter
    //

    protected get tutorialSpotlight(): Library.PokerTutorial.PokerTutorialSpotlight {
        return this.disp as Library.PokerTutorial.PokerTutorialSpotlight;
    }

    get hasSpotLight(): boolean {
        return this._hasSpotLight;
    }

    set hasSpotLight(value: boolean) {
        this._hasSpotLight = value;
    }

    public destroy(): void {
        this._spotLightRect = null;
    }

    //
    // end
    //
}
